export const FETCH_TPA_DATA_STATUS = {
    INITIAL: 'INITIAL',
    FETCHING: 'FETCHING',
    DONE: 'DONE'
}
